module.exports = __webpack_public_path__ + "static/img/2.5882033.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/sp/2.png
// module id = 7Urq
// module chunks = 0